<template>
    <div id="pageContent" class="page-container" v-loading="loading">
<!--        <iframe ref="webIframe" class="web" frameborder="0" :src="`https://preview.emof.cn/onlinePreview?url=${file_url}`" v-if="file_url"></iframe>-->
    </div>
</template>

<script>

import {getEnclosureById} from "@/api";
export default {
    data() {
        return {
            file_url: '',
            loading: false
        }
    },
    computed: {},
    created() {
        if (this.$route.query.type){
            this.init()
        }else {
            this.file_url = this.$route.query.url
        }
        this.handlePaste()
    },
    methods: {
        handlePaste() {
            let _this = this
            _this.$nextTick(() => {

                // 禁用右键
                window.document.oncontextmenu = function () {
                    return false
                }
                // 禁用选择
                window.document.onselectstart =function () {
                    return false
                }
                //禁止f12
                window.document.οnkeydοwn = function () {
                    return false
                }

            })
            window.oncontextmenu = function () {
                return false
            }
            // 如禁止f12 代码没生效，加下面这段
            window.onkeydown = function (e) {
                console.log(e)
                if (e && e.keyCode === 123) {
                    e.returnValue = false
                    // e.keyCode = 0   //去掉也可以，如果要写，则需要setter + getter配合使用，不然则会报错
                    return false
                }
            }
        },

        async init() {
            this.loading = true
            let _data = await getEnclosureById(this.$route.query.fid,this.$route.query.type)
            this.loading = false
            document.title = _data.data.file_name
            // this.file_url = encodeURIComponent(_data.data.file_url)
            location.href = `http://preview.emof.cn/onlinePreview?url=${encodeURIComponent(_data.data.file_url)}`
        },
    },
    components: {},
    watch: {}
}
</script>

<style lang="scss" scoped>
.page-container {
    overflow: hidden;
    height: 100vh;
    position: relative;

    .web {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        overflow-clip-margin: 0 !important;
        border-width: 0;
        border-style: unset;
        border-color: unset;
        border-image: unset;
        overflow: clip !important;
        -ms-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
}
</style>